import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { userService } from "../services/svc_users";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest } from "../types/common/commonTypes";

export const useTSQUserList = (params: ListRequest) => {
  return useQuery({
    queryKey: queryKeys.user.list(params),
    queryFn: () => userService.list(params),
    placeholderData: keepPreviousData,
  });
};

export const useTSQUser = (id: string) => {
  return useQuery({
    queryKey: queryKeys.user.detail(id),
    queryFn: () => userService.getById(id),
    enabled: !!id,
  });
};

export const useTSMCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.lists() });
    },
    onError: (error) => {
      console.error("Failed to create User:", error);
    },
  });
};

export const useTSMUpdateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      userService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.lists() });
    },
    onError: (error) => {
      console.error("Failed to create User:", error);
    },
  });
};

export const useTSMDeactivateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userService.deactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.lists() });
    },
    onError: (error) => {
      console.error("Failed to deactivate User:", error);
    },
  });
};

export const useTSMReactivateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: userService.reactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.user.lists() });
    },
    onError: (error) => {
      console.error("Failed to reactivate User:", error);
    },
  });
};
